module.exports = __webpack_public_path__ + "img/feature_tags.affd70eb.png";